import Vue from 'vue';
import QuickSearchLayout from "../plugins/page/QuickSearchLayout.vue";
import QuickIconButton from "../plugins/page/QuickIconButton.vue";


Vue.component("QuickSearchLayout", QuickSearchLayout);
Vue.component("QuickIconButton", QuickIconButton);